import { render, staticRenderFns } from "./DruzstevneByvanie.vue?vue&type=template&id=640a2fc8&scoped=true"
import script from "./DruzstevneByvanie.vue?vue&type=script&lang=js"
export * from "./DruzstevneByvanie.vue?vue&type=script&lang=js"
import style0 from "./DruzstevneByvanie.vue?vue&type=style&index=0&id=640a2fc8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a2fc8",
  null
  
)

export default component.exports